<template>
  <ion-page>
    <ion-content scroll-y="false" :fullscreen="true">
      <div id="screen1">
        <br />
        <br />
        <div class="iosSafeHeight" />
        <ion-list lines="full" class="ion-no-margin" id="chatlistcontainer2">
          <ion-item v-for="(m, i) in messages" :key="i">
            <profile-picture
              :isChat="true"
              v-if="!isMessageFromMe(m)"
              :id="m.authorId"
            />
            <ion-label text-wrap :class="messageClassFor(m)">
              {{ m.profile.name }}: <br />
              {{ m.messageText }}
            </ion-label>
            <profile-picture
              :isChat="true"
              v-if="isMessageFromMe(m)"
              :id="m.authorId"
            />
          </ion-item>
        </ion-list>
        <ion-footer>
          <ion-item>
            <ion-input
              v-model="newMessageText"
              placeholder=""
              type="text"
            ></ion-input>
            <ion-button @click="sendMessage">Send</ion-button>
          </ion-item>
          <ion-item class="sendMessageContainer" />
        </ion-footer>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonContent,
  IonPage,
  IonList,
  IonLabel,
  IonInput,
  IonItem,
  IonButton,
  IonFooter,
  popoverController,
  alertController,
} from "@ionic/vue";
import router from "../router";
import { defineComponent } from "vue";
import network from "../network";
import { bus } from "../main";
import PopoverContent from "../componets/Chat/PopoverContent.vue";
import ProfilePicture from "../componets/Profile/ProfilePicture.vue";
import { IChat } from "@/structs/structs";

let presentingMenu = false;

export default defineComponent({
  name: "Login",
  components: {
    IonContent,
    IonPage,
    IonList,
    IonLabel,
    IonInput,
    IonItem,
    IonButton,
    IonFooter,
    ProfilePicture,
  },
  data() {
    return {
      messages: [] as {}[],
      newMessageText: "",
      messagesUnsubscribeRef: undefined as any,
      popover: null as any,
      chatDetails: {} as IChat,
      chatPartnerId: "",
    };
  },
  computed: {
    chatId(): string {
      return this.$route.params.chatId as string;
    },
  },
  async mounted() {
    this.chatDetails = (await network.getChatsDetails([this.chatId]))[0];
    const idFrom = this.chatDetails.from;
    const idTo = this.chatDetails.to;
    const myId = network.getAuthUser()?.uid;
    this.chatPartnerId = myId === idTo ? idFrom : idTo;

    this.messagesUnsubscribeRef = await network.subscribeForMessaging(
      this.chatId,
      (snapshot: {}[]) => {
        this.messages = snapshot;
        this.scrollToBottom();
      },
      (error: any) => {
        console.log("Error: " + error);
      }
    );

    const safePresentCall = function (func: any) {
      // presentingMenu this fudge is needed because function ends up being called multiple times if you change between top-level items a few times.
      // A better solution should be done at some point
      if (presentingMenu !== false) {
        return;
      }
      presentingMenu = true;
      setTimeout(() => {
        func();
        presentingMenu = false;
      }, 50);
    };

    bus.on("ellipsisClicked", async (ev: Event) => {
      safePresentCall(async () => {
        this.popover = await popoverController.create({
          component: PopoverContent,
          cssClass: "my-custom-class",
          event: ev,
          translucent: true,
        });
        return this.popover.present();
      });
    });
    /*
    bus.on("ellipsisClicked", async (ev: Event) => {
      this.popover?.dismiss();

      safePresentCall(async () => {
        const alert = await alertController.create({
          cssClass: "my-custom-class",
          header: "",
          message: "",
          buttons: [
            {
              text: "Profile For Chat Partner",
              role: "secondary",
              cssClass: "secondary",
              handler: () => {
                bus.emit("chatPopoverGetProfile");
              },
            },
            {
              text: "Block User",
              role: "secondary",
              cssClass: "secondary",
              handler: () => {
                bus.emit("chatPopoverBlockUser");
              },
            },
            {
              text: "Report and Block User",
              role: "secondary",
              cssClass: "secondary",
              handler: () => {
                bus.emit("chatPopoverReportAndBlock");
              },
            },
          ],
        });
        alert.present();
      });
    });
    */
    bus.on("chatPopoverGetProfile", () => {
      this.popover?.dismiss();
      router.push("/profile/" + this.chatPartnerId);
    });

    bus.on("chatPopoverBlockUser", async () => {
      this.popover?.dismiss();
      safePresentCall(async () => {
        const alert = await alertController.create({
          cssClass: "my-custom-class",
          header: "Block User?",
          message:
            "This will remove you from this Chat and is Irreversible. The other user will not find you again in Search",
          buttons: [
            {
              text: "Cancel",
              role: "cancel",
              cssClass: "secondary",
              handler: () => {
                console.log("block cancelled");
              },
            },
            {
              text: "Delete and Block",
              cssClass: "primary",
              handler: async () => {
                await network.blockUserAndLeaveChat(
                  this.chatPartnerId,
                  this.chatId
                );

                this.actionConfirmed(
                  "Block User",
                  "User Blocked and Removed from Chat",
                  () => {
                    bus.emit("jumpToLink", "/chats");
                  }
                );
              },
            },
          ],
        });
        alert.present();
      });
    });

    bus.on("chatPopoverReportAndBlock", async () => {
      this.popover?.dismiss();
      safePresentCall(async () => {
        const alert = await alertController.create({
          cssClass: "my-custom-class",
          header: "Block and Report User?",
          message:
            "This will remove you from this Chat and is Irreversible. The other user will not find you again in Search. Messages in chat will be checked for harassment or breach of T&Cs",
          inputs: [
            {
              name: "reason",
              id: "reason-id",
              value: "",
              placeholder: "Reason (Optional)",
            },
          ],
          buttons: [
            {
              text: "Cancel",
              role: "cancel",
              cssClass: "secondary",
              handler: () => {
                console.log("report cancelled");
              },
            },
            {
              text: "Delete, Block and Report",
              cssClass: "primary",
              handler: async (event) => {
                const reason = event.reason;
                await network.reportChat(
                  this.chatPartnerId,
                  this.chatId,
                  reason
                );
                await network.blockUserAndLeaveChat(
                  this.chatPartnerId,
                  this.chatId
                );

                this.actionConfirmed(
                  "Report and Block",
                  "Report has been sent",
                  () => {
                    bus.emit("jumpToLink", "/chats");
                  }
                );
              },
            },
          ],
        });
        alert.present();
      });
    });
  },
  unmounted() {
    if (this.messagesUnsubscribeRef !== undefined) {
      this.messagesUnsubscribeRef();
    }
  },
  methods: {
    async actionConfirmed(header: string, message: string, closeFunc: any) {
      const alert = await alertController.create({
        cssClass: "my-custom-class",
        header,
        message,
        buttons: [
          {
            text: "OK",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              closeFunc();
            },
          },
        ],
      });
      alert.present();
    },
    isMessageFromMe(message: any) {
      return message.authorId === network.getAuthUser()?.uid;
    },
    messageClassFor(message: any) {
      return this.isMessageFromMe(message) ? "ion-text-end" : "ion-text-start";
    },
    scrollToBottom() {
      setTimeout(() => {
        const objDiv: any = document.getElementById("chatlistcontainer2");
        objDiv.scrollTop = objDiv.scrollHeight + 9999;
      }, 200);
    },
    sendMessage() {
      if (this.newMessageText.trim() === "") {
        return; // Do not send an empty message
      }

      const messageObj = {
        messageText: this.newMessageText,
        timestamp: Date.now(),
        authorId: network.getAuthUser()?.uid || "",
      };
      this.newMessageText = "";

      this.scrollToBottom();

      network.sendMessage(this.chatId, messageObj, (error: any) => {
        console.log("Error: " + error);
      });
    },
  },
});
</script>

<style scoped>
ion-menu-button {
  color: var(--ion-color-primary);
}

.iosSafeHeight {
  height: env(safe-area-inset-top);
}

.sendMessageContainer {
  height: env(safe-area-inset-bottom);
}

#screen1 {
  height: calc(100%);
  display: flex;
  flex-flow: column;
}

#chatlistcontainer2 {
  flex-grow: 1;
  overflow-y: scroll;
}

#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}

.my-custom-class .popover-content {
  background: #222;
}
</style>